
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { GlobalConstants } from '../../../common/constants/global.constant';
import { environment } from '../../../../environments/environment';
import { SelectLanguageConstants } from '../../../common/components/select-lang/constants/select-lang.consts';
import { LANGUAGE_MAPPINGS } from '../../../common/constants/language-mappings.const';
import { CommonService } from '../../../common/services/common.service';
import { AppGlobal } from '../../../core/state/app-global';
import { User } from '../../account/login/_models/user.model';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import { Subject } from 'rxjs/internal/Subject';
import { first } from 'rxjs/internal/operators/first';
import { Utils } from '../../../common/utils/utils';
import { DateFormatPipe } from '../../pipes/pipe-util/date-formate.pipe';
import { GoogleAnalyticsService } from '../../google-analytics/google-analytics.service';
import { WebsocketService } from '../../../core/routing/services/websocket/websocket.service';
import { NgbModal, NgbTooltip} from '@ng-bootstrap/ng-bootstrap';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import { HttpMethodsService } from '../../../core/routing/services/_helpers/http-methods.service';
import { AssetLibraryConstants } from '../../../core/routing/services/asset-library/constants/asset-library.constant';
import { map } from 'rxjs/internal/operators/map';
@Component({
  selector: 'iposcen-standard-download',
  templateUrl: './standard-download.component.html',
  styleUrls: ['./standard-download.component.scss'],
  providers: [DateFormatPipe],
})
export class StandardDownloadComponent implements OnInit {
  @ViewChild('searchValue') animateThis: ElementRef;
  @ViewChild('addTemplate') public addTemplate!: NgbTooltip;
  openModalPopup: boolean;
  openProgressPopup: boolean;
  languageJSON = [] as any;
  chromelanguageJSON = [] as any;
  browserLanguage: string;
  count = 0;
  globalconst = GlobalConstants;
  selectedLanguage: string;
  selectedLangCode: string;
  langForm: FormGroup;
  languageHeading = SelectLanguageConstants.LANGUAGE_HEADING;
  searchLanguageName = SelectLanguageConstants.SEARCH_LANGUAGE;
  searchData: string;
  searchClose: boolean;
  cloneFilterLanguage: any;
  windowsOS = GlobalConstants.WINDOWS;
  iposLite = GlobalConstants.IPOS_LITE;
  linuxOS = GlobalConstants.LINUX;
  creatorOS = 'Creator';
  generatePackageSelectTitle = GlobalConstants.GENERATE_PACKAGE_SELECT_LINUX_TITLE;
  generatePackageSelectLinuxiso = GlobalConstants.GENERATE_PACKAGE_LINUX_ISO;
  generatePackageSelectLinuxipos = GlobalConstants.GENERATE_PACKAGE_LINUX_IPOS;
  packageProgressTitle = GlobalConstants.GENERATE_PACKAGE_PROGRESS_TITLE;
  selectlinuxospackagePopup: boolean;
  downloadPackageName = GlobalConstants.DOWNLOAD_PACKAGE_TITLE;
  downloadBtnText = GlobalConstants.DOWNLOAD;
  cancelBtnName = GlobalConstants.CANCEL;
  generateBtnName = GlobalConstants.GENERATE_PACKAGE;
  currentDownoadURLExtention: string;
  windowExt = GlobalConstants.FILE_EXTENSION_ZIP;
  windowUWPExt = GlobalConstants.FILE_EXTENSION_ZIP;
  packageType: string;
  userInfo: User;
  storeUser = GlobalConstants.STORE_USER;
  retailUser = GlobalConstants.RETAIL_HQ_USER;
  regionalHQUser = GlobalConstants.REGIONALHQ;
  isStandard: boolean = false;
  isGenerating: any = {};
  runInteval: any;
  download = GlobalConstants.DOWNLOAD;
  generating = GlobalConstants.GENERATING;
  generateText = GlobalConstants.GENERATE;
  error = GlobalConstants.PACKAGE_GENERATE_ERROR;
  PKG_DOWNLOAD_ERROR = GlobalConstants.PACKAGE_DOWNLOAD_ERROR_TEXT;
  DOWNLOAD_BTN = GlobalConstants.PACKAGE_DOWNLOAD_BUTTON;
  GAMING = GlobalConstants.GAMING;
  STANDARD = GlobalConstants.STANDARD;
  UWP = GlobalConstants.UWP;
  LINUX = GlobalConstants.LINUX;
  CHROME = GlobalConstants.CHROME_TEXT;
  chromebook_title = GlobalConstants.CHROMEBOOK_UPR;
  chromebok_desc = GlobalConstants.CHROMEBOOK_IPOS;
  iposChina_title = GlobalConstants.IPOS_LITE_PRC;
  iposChina_desc = GlobalConstants.IPOS_CHINA_DESC;
  addTemplateText = GlobalConstants.IPOS_LITE_ADD_TEMPLATE;
  templateNoteText = GlobalConstants.UPLOAD_CSV_NOTE;
  downloadTemplateText = GlobalConstants.IPOS_LITE_DOWNLOAD_TEMPLATE;
  uploadTemplateText = GlobalConstants.IPOS_LITE_UPLOAD_PRODUCT_MAP;
  stepToDownloadOne = GlobalConstants.IPOS_LITE_TO_DOWNLOAD_TEMPLATE;
  packageRef: any = {};
  packageFileName: string;
  selectedLangTooltip: string;
  selectedLangObject: any = {};
  selectLangConst = SelectLanguageConstants.SELECT_LANGUAGE;
  isRussian = localStorage.getItem('preferredLanguage') === 'ru';
  isUkraine = localStorage.getItem('preferredLanguage') === 'uk';
  isGreek = localStorage.getItem('preferredLanguage') === 'el';
  isHungarian = localStorage.getItem('preferredLanguage') === 'hu';
  isFrench = localStorage.getItem('preferredLanguage') === 'fr';
  isItalian = localStorage.getItem('preferredLanguage') === 'it';
  isJapanese = localStorage.getItem('preferredLanguage') === 'ja';
  isKorean = localStorage.getItem('preferredLanguage') === 'ko';
  isCzech = localStorage.getItem('preferredLanguage') === 'cs';
  isNorwegian = localStorage.getItem('preferredLanguage') === 'nb';
  isSpanishMexico = localStorage.getItem('preferredLanguage') === 'es-mx';
  isSpanish = localStorage.getItem('preferredLanguage') === 'es';
  isArabic = localStorage.getItem('preferredLanguage') === 'ar-sa';
  isHebrew = localStorage.getItem('preferredLanguage') === 'he';
  langMappingsClone = LANGUAGE_MAPPINGS;
  showRetailGif = false;
  stgPkgData: any = {};
  downloadPopUpData: any = {};
  showDownloadPopup: boolean = false;
  cross: boolean;
  pkgMetaData: any = {}; // To maintain metadata packages
  dummypkgMetaData = JSON.parse(JSON.stringify(this.pkgMetaData));
  isDataLoading: boolean = false;
  isGamingMessage: boolean = false;
  standarPackageResults = [];
  gamingPackageMsgText = GlobalConstants.GAMING_PKG_USB_MSG;
  pkgLangForGA = '';
  enableGameDemosPopup: boolean = false;
  modalReference: any;
  translatedVal= {
    download : GlobalConstants.DOWNLOAD,
    generating : GlobalConstants.GENERATING,
    generate : GlobalConstants.GENERATE
  }
  isIposChinaEnabled = false;
  userId = sessionStorage.getItem('userId');
  private ngUnsubscribe = new Subject<boolean>();
  PMFileExists: boolean;
  templateName = 'ProductMapping';
  fileName: any;
  file: any;
  showFileContentError: boolean;
  showXlsxError: boolean;
  retailerId: string;
  uploadedDate: string;
  clickHereDownload = GlobalConstants.CLICK_DOWNLOAD;
  showProductmapping: boolean = false;
  constructor(private googleAnalyticsService: GoogleAnalyticsService,
    private formbuilder: FormBuilder,
    private commonService: CommonService,
    private appGlobal: AppGlobal,
    private dateformatPipe: DateFormatPipe,
    private websocketService: WebsocketService,
    private modalService: NgbModal,private httpMethodsservice: HttpMethodsService
  ) { }

  ngOnInit(): void {
    // this.openModalPopup = true;
    this.isDataLoading = true;
    this.cross = false;
    this.searchClose = false;
    this.file = {};
    this.browserLanguage = (localStorage.getItem('preferredLanguage')) ? localStorage.getItem('preferredLanguage') : GlobalConstants.LANGUAGE_ENGLISH; // if nothing exists in storage
    this.browserLanguage = (this.browserLanguage === 'zh-Hant') ? 'zh-tw' : this.browserLanguage; 
    this.pkgMetaData = Utils.getPkgMetaData();
    this.loadJSONObject(this.browserLanguage);
    this.chromelanguageJSON = Utils.filterChromeLanguages();
    let lan=this.browserLanguage;
    let nonChromeLang=this.chromelanguageJSON.filter((value) => {
       if(lan.includes(value.langCode))       
        return true;
    });
    if(!nonChromeLang.length){
    this.pkgMetaData.chromebook.langObject = {
      langCode: "en-US", langName: "English - United States",
      langInEng: "English - United States"
    }}    
    this.langForm = this.formbuilder.group({
      lang: new FormControl('', [Validators.required])
    });
    this.commonService.getPackageStatus.subscribe(data => {
      this.commonService.removeExistingPackage()
        .pipe(takeUntil(this.ngUnsubscribe))
        .pipe(first())
        .subscribe(response => {
          this.isGenerating = {};
          this.openProgressPopup = false;
          this.commonService.emitNavZIndex(false);
          this.commonService.setisPackageGenerating(this.isGenerating);
        });
    })
    // Get the loggedin user object
    this.appGlobal.$userAccount
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((userData: User) => {
        // Make a copy of the user object
        this.userInfo = { ...userData };
        this.fetchStdPkgData();
        if ((this.userInfo?.role === GlobalConstants.NON_CONNECTED_USER && localStorage.getItem('preferredLanguage') === 'zh-Hans') || (this.userInfo?.role === GlobalConstants.INTEL_ADMIN)) {
          this.isIposChinaEnabled = this.showProductmapping = true;
        }
        if (this.userInfo.role === this.storeUser || this.userInfo.role === this.retailUser || this.userInfo.role === this.regionalHQUser) {
          this.isStandard = true;
          this.userId = this.userInfo.userId;
          this.retailerId = this.userInfo.retailerID;
          const value = this.commonService.getRetailerConfig(this.userId, sessionStorage.getItem('retailerId'))?.
            then((value) => {
              this.isIposChinaEnabled = value?.['isIposChinaEnabled'] || false;
              this.showProductmapping = value?.['enableVA'] || false;
            },
              (error) => {
                // Error!
              }
            );
        }
      });
    this.commonService.getRetailGifValue
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(data => {
        if (data) {
          this.showRetailGif = true;
          setTimeout(() => {
            this.showRetailGif = false;
            this.commonService.setRetailGifValue(false);
          }, 1000);
        }
      });
      this.getUploadedFile();
        }

  ngOnDestroy(): void {
    clearInterval(this.runInteval);
    this.runInteval = 0;
    this.commonService.emitNavZIndex(false);
  }

  loadJSONObject(defaultLanguage: string): void {
    //Changing selected language from 4 letter language codes to 2
    if (defaultLanguage === 'zh-Hans') {
      defaultLanguage = 'zh-cn';
    } else if (defaultLanguage === 'zh-Hant') {
      defaultLanguage = 'zh-tw';
    }
    this.languageJSON = [];
    this.langMappingsClone.forEach(element => {
      let display = false;
      if (element.langCode === 'zh-Hans') {
        element.langCode = 'zh-cn';
      } else if (element.langCode === 'zh-Hant') {
        element.langCode = 'zh-tw';
      }
      if (defaultLanguage === element.langCode) {
        display = true;
        this.count = 1;
        this.selectedLanguage = element.langName;
        this.selectedLangCode = element.langCode;
        this.selectedLangObject = {
          langName: element.langName,
          langInEng: element.langInEng,
          langCode: element.langCode
        };
        this.selectedLangTooltip = element.langName;
      }
      const language = {
        langCode: element.langCode,
        langName: element.langName,
        langInEng: element.langInEng,
        checked: display
      };
      this.languageJSON.push(language);
    });
    this.cloneFilterLanguage = this.languageJSON;
    this.pkgMetaData.standard.langObject = this.pkgMetaData.uwp.langObject = this.pkgMetaData.creator.langObject = this.pkgMetaData.chromebook.langObject = this.pkgMetaData.iso.langObject = this.pkgMetaData.deb.langObject = this.pkgMetaData.gaming.langObject = JSON.parse(JSON.stringify(this.selectedLangObject));
    this.setChineseLang();
  }
  getUploadedFile() {
    const url = AssetLibraryConstants.S3_ASSET_LIBRARY_RETAILERS + sessionStorage.getItem('retailerId')
      + '/product-mapping/Product-Mapping';
    return this.httpMethodsservice.getImage(url, true)
      .pipe(map((res: any) => res)).subscribe(() => {
        this.PMFileExists = true;
        this.commonService.getProductMapDetails(sessionStorage.getItem('retailerId')).pipe(takeUntil(this.ngUnsubscribe)).pipe(first()).subscribe(response => {
         this.uploadedDate = response?.standardPackage?.productMapLastUpdatedTime;
        });
      });
  }

  closeModal() {
    this.count = 0;
    this.openModalPopup = false;
    this.showDownloadPopup = false;
  }
  setChineseLang() {
    if (this.pkgMetaData?.iposlite) {
        LANGUAGE_MAPPINGS.forEach((lang)=> { 
          if(lang.langCode === 'zh-cn') {
            this.pkgMetaData.iposlite.langObject = {
              langCode: lang.langCode,
              langName: lang.langName,
              langInEng: lang.langInEng
            }
          }
        })
    }
  }

  setButtonText(selectedName: string, selectedCode: string) {
    this.count = 1;// setting to 1 so that we can validate while preapring download URL
    this.selectedLanguage = selectedName;
    this.selectedLangCode = selectedCode;
  }

  selectDownloadPackage(checkType, checkExtension, TYPE, pkgType) {
    this.commonService.operatingSystemType = TYPE;
    this.isStandard = false;
        if (this.userInfo.role === this.storeUser || this.userInfo.role === this.retailUser || this.userInfo.role === this.regionalHQUser) {
      this.isStandard = true;
    }
    if (checkType === this.windowsOS) {

      // this.packageType = (TYPE === this.STANDARD) ? GlobalConstants.STD_PACKAGE_DOWNLOAD : GlobalConstants.LINUX_PACKAGE_NAME;
      if (TYPE === this.CHROME) {
        this.packageType = GlobalConstants.CB_PACKAGE_DOWNLOAD;
        this.langMappingsClone = Utils.filterChromeLanguages();
      }
      else if (TYPE === this.STANDARD) {
        this.langMappingsClone = LANGUAGE_MAPPINGS;
        this.packageType = GlobalConstants.STD_PACKAGE_DOWNLOAD;
      }
      else if (TYPE === this.UWP) {
        this.packageType = GlobalConstants.UWPSTD_PACKAGE_DOWNLOAD;
      }
      else {
        this.langMappingsClone = LANGUAGE_MAPPINGS;
        this.packageType = GlobalConstants.LINUX_PACKAGE_NAME;
      }
      this.openModalPopup = true;
      this.currentDownoadURLExtention = checkExtension;

      if (TYPE === this.GAMING) {

        this.packageRef.packagetype = GlobalConstants.PACKAGE_TYPE_WIN;
        this.packageRef.standardpack = GlobalConstants.GAMING_LWR;
        this.packageRef.operatingsystem = GlobalConstants.WINDOWS_OS_LWR;
      } else if (TYPE === this.STANDARD) {
        this.packageRef.packagetype = GlobalConstants.PACKAGE_TYPE_WIN;
        this.packageRef.standardpack = GlobalConstants.STANDARD_PACKAGE;
        this.packageRef.operatingsystem = GlobalConstants.WINDOWS_OS_LWR;
      } else if (TYPE === this.CHROME) {
        this.packageRef.packagetype = GlobalConstants.CHROME_LWR;
        this.packageRef.standardpack = GlobalConstants.STANDARD_PACKAGE;
        this.packageRef.operatingsystem = GlobalConstants.WINDOWS_OS_LWR;
      }
      else if (TYPE === this.UWP) {
        this.packageRef.packagetype = GlobalConstants.UWP;
        this.packageRef.standardpack = GlobalConstants.UWP_STANDARD_PACKAGE;
        this.packageRef.operatingsystem = GlobalConstants.WINDOWS_OS_LWR;
      }

    } else if (checkType === this.linuxOS) {
      this.langMappingsClone = LANGUAGE_MAPPINGS;
      this.packageType = GlobalConstants.STD_PACKAGE_DOWNLOAD;
      if (pkgType === GlobalConstants.ISO_TEXT) {
        this.onGenerateLinuxISO(1);
      } else {
        this.onGenerateLinuxISO(2);
      }
    } else if (checkType === this.creatorOS) {
      this.langMappingsClone = LANGUAGE_MAPPINGS;
      this.currentDownoadURLExtention = checkExtension;
      this.packageType = GlobalConstants.CREATOR_PACKAGE_DOWNLOAD;
      this.openModalPopup = true;
      this.packageRef.packagetype = GlobalConstants.PACKAGE_TYPE_WIN;
      this.packageRef.standardpack = GlobalConstants.CREATOR_PACKAGE;
      this.packageRef.operatingsystem = GlobalConstants.WINDOWS_OS_LWR;
    } else if (checkType === this.iposLite) {
      this.langMappingsClone = LANGUAGE_MAPPINGS ;
      this.currentDownoadURLExtention = checkExtension;
      this.packageType = GlobalConstants.IPOSLITE_PACKAGE_DOWNLOAD;
      this.openModalPopup = true;
      this.packageRef.packagetype = this.packageRef.standardpack = this.packageRef.operatingsystem = this.iposLite;
    }
    this.packageRef.ext = this.currentDownoadURLExtention;
    this.searchClose = false;
    this.searchData = '';
    this.selectedLangCode = this.pkgMetaData[pkgType].langObject?.langCode;
    this.generatePackage();
    if (this.pkgMetaData[pkgType]?.data?.length) {
      this.pkgMetaData[pkgType].data[0].packageStatus = GlobalConstants.PND_LWR;
    } else {
      this.pkgMetaData[pkgType].data = [{ 'packageStatus': GlobalConstants.PND_LWR }]
    }
  }

  trackByLanguage(index: number, el: string): number {
    return index;
  }

  downloadStdPackage() {
    const filename = this.currentDownoadURLExtention === GlobalConstants.FILE_EXTENSION_DEB ? GlobalConstants.IPOS_APPLICATION_NAME : GlobalConstants.IPOS_NAME;
    const downloadUrl = environment.apiBaseUrl + this.packageType + this.selectedLangCode.toLowerCase() + filename + this.currentDownoadURLExtention;
    const date = new Date();
    const currentDate = ((date.getMonth() > 8) ? (date.getMonth() + 1) : ('0' + (date.getMonth() + 1))) + '' + ((date.getDate() > 9) ? date.getDate() : ('0' + date.getDate())) + '' + date.getFullYear();
    let downloadFileName = 'LinuxIPOS_ ' + currentDate;
    if (this.commonService.operatingSystemType === this.CHROME) {
      downloadFileName = 'ChromebookIPOS_' + currentDate;
      this.googleAnalyticsService.PackageTypeCreated(this.commonService.operatingSystemType);
      this.googleAnalyticsService.downloadChromebookIpos();
    }
    else if (this.commonService.operatingSystemType === this.STANDARD) {
      downloadFileName = 'StandardIPOS_' + currentDate;
      this.googleAnalyticsService.PackageTypeCreated(this.commonService.operatingSystemType);
      this.googleAnalyticsService.downloadStandardIpos();
    } else if (this.commonService.operatingSystemType === this.GAMING) {
      downloadFileName = 'GamingIPOS_' + currentDate;
      this.googleAnalyticsService.PackageTypeCreated(this.commonService.operatingSystemType);
      this.googleAnalyticsService.downloadGamingIpos();
    } else if (this.commonService.operatingSystemType === this.LINUX) {
      downloadFileName = 'LinuxIPOS_' + currentDate;
      this.googleAnalyticsService.PackageTypeCreated(this.commonService.operatingSystemType);
      this.googleAnalyticsService.downloadLinuxIpos();
    } else if (this.commonService.operatingSystemType === this.creatorOS) {
      downloadFileName = 'CreatorIPOS_' + currentDate;
      this.googleAnalyticsService.PackageTypeCreated(this.commonService.operatingSystemType);
      this.googleAnalyticsService.downloadCreatorIpos();
    } else if (this.commonService.operatingSystemType === this.iposLite) {
      downloadFileName = 'LiteIPOS_' + currentDate;
      // this.googleAnalyticsService.PackageTypeCreated(this.commonService.operatingSystemType);
      // this.googleAnalyticsService.downloadCreatorIpos();
    }
    this.googleAnalyticsService.downloadIpos(this.commonService.operatingSystemType, this.selectedLangCode);
    if (this.count) {
      this.commonService.downloadPackage(downloadUrl, downloadFileName, this.currentDownoadURLExtention);
      this.onCloseSelectPackagePopup();
    }
  }

  //for connected users
  generatePackage() {
    let userType = (this.userInfo.role === this.storeUser || this.userInfo.role === this.retailUser || this.userInfo.role === this.regionalHQUser) ? GlobalConstants.CNCTD_LWR : GlobalConstants.UNCNCTD_LWR;
    this.openModalPopup = false;
        this.isGenerating = {
      payloadData: {
        packagetype: this.packageRef.packagetype,
        locale: (this.packageRef.packagetype === this.iposLite) ? 'zh-cn' : this.selectedLangCode.toLowerCase(),
        standardpack: (this.packageRef.packagetype === GlobalConstants.CHROME_LWR) ? GlobalConstants.CHROME_LWR : (this.packageRef.packagetype === GlobalConstants.UWP_STANDARD_PACKAGE) ? GlobalConstants.UWP_STANDARD_PACKAGE : this.packageRef.standardpack,
        operatingsystem: this.packageRef.operatingsystem
      },
      retailerID: sessionStorage.getItem('retailerId'),
      status: this.generating,
      date: new Date(),
      extention: this.packageRef.ext
    };
    this.commonService.gernerateConnectedUserPackage(this.isGenerating, userType)
      .pipe(takeUntil(this.ngUnsubscribe))
      .pipe(first())
      .subscribe(response => {
        this.estabhilishWS();
      });
  }

  //start polling
  checkPackageGeneratingStatus() {
    //check if packaging started 8/15 mins before 
    this.runInteval = setInterval(() => {
      let frequencyMinsToCheck = (this.isGenerating.payloadData.standardpack === GlobalConstants.GAMING_LWR) ? environment.gamingPollFrequency : environment.pollFrequency;
      let timeDiff = Utils.getDifference(this.isGenerating.date);
      if (timeDiff < frequencyMinsToCheck) {
        this.commonService.getpackageStatus()
          .pipe(takeUntil(this.ngUnsubscribe))
          .subscribe(response => {
            //once we got the required repsonse we can stop
            clearInterval(this.runInteval);
            this.runInteval = 0;
            this.isGenerating = this.commonService.getisPackageGeneratingVal();
            this.isGenerating.status = this.download;
            this.openProgressPopup = false;
            let pkgName = 'Linux';
            if (this.commonService.operatingSystemType === this.CHROME) {
              pkgName = this.CHROME;
            }
            else if (this.commonService.operatingSystemType === this.STANDARD) {
              pkgName = 'Standard';
            } else if (this.commonService.operatingSystemType === this.GAMING) {
              pkgName = 'Gaming';

            } else if (this.commonService.operatingSystemType === this.creatorOS) {
              pkgName = 'Creator';
            } else if (this.commonService.operatingSystemType === this.iposLite) {
              pkgName = this.iposLite;
            } 
            this.packageFileName = pkgName + "_" +
              Utils.decodeLanguageByCode(this.isGenerating?.payloadData?.locale) + "_" +
              this.dateformatPipe.transform(this.isGenerating?.date, "changeToLocalDisplay");
            this.isGenerating.packageFileName = this.packageFileName;
            this.commonService.emitNavZIndex(false);
            this.commonService.setisPackageGenerating(this.isGenerating);
          });
      } else {
        clearInterval(this.runInteval);
        this.runInteval = 0;
        this.isGenerating.status = this.error;
        this.openProgressPopup = false;
        this.commonService.setisPackageGenerating({}); // Setting it to blank. for a new session
        this.commonService.emitNavZIndex(false);
      }
    }, 10000);
  }

  clearSearch() {
    this.searchClose = false;
    this.languageJSON = [];
    this.searchData = '';
    this.cross = false;
    this.loadJSONObject(this.selectedLangCode);
  }

  searchLanguage() {
    this.cross = true;
    this.animateThis.nativeElement.blur();
    if (!this.searchData) {
      this.searchClose = false;
      this.clearSearch();
    } else {
      this.searchClose = true;
      const result = this.languageJSON.filter(ele => ele.langInEng.toLowerCase()
        .includes(this.searchData.toLowerCase()));
      this.languageJSON = result;
    }
  }

  onCloseSelectPackagePopup() {
    this.count = 0;
    this.selectlinuxospackagePopup = false;
    this.openModalPopup = false;
  }

  onGenerateLinuxISO(values) {
    if (this.userInfo.role === this.storeUser || this.userInfo.role === this.retailUser || this.userInfo.role === this.regionalHQUser) {
      this.isStandard = true;
    }
    this.currentDownoadURLExtention = this.isGenerating.extention = (values === 1) ? GlobalConstants.FILE_EXTENSION_ISO : GlobalConstants.FILE_EXTENSION_DEB;
    this.packageRef.packagetype = (values === 1) ? GlobalConstants.PACKAGE_TYPE_ISO : GlobalConstants.PACKAGE_TYPE_DEB;
    this.packageRef.standardpack = GlobalConstants.STANDARD_PACKAGE;
    this.packageRef.operatingsystem = GlobalConstants.LINUX_LWR;
    this.packageRef.ext = this.currentDownoadURLExtention;
  }

  downloadConnectedUserPackage() {
    this.commonService.downloadPackage(environment.apiBaseUrl + this.isGenerating.URL, this.isGenerating.packageFileName, this.isGenerating.extention);
  }

  //IIT2-5802
  getSelectedLanguage(e, langObj) {
    if (e) {
      this.pkgMetaData[langObj].langObject = Object.assign(this.pkgMetaData[langObj].langObject, {
        langName: e.langName,
        langInEng: e.langInEng,
        langCode: e.langCode
      });
      this.pkgMetaData[langObj]['data'] = this.filterPkgData(this.pkgMetaData[langObj]);
      this.setButtonText(e.langName, e.langCode);
    } else {
      this.pkgMetaData[langObj].langObject = {};
    }
  }
  //IIT2-5802
  fetchStdPkgData() {
        this.estabhilishWS();
  }
  estabhilishWS() {
       let connectionWS = 0;
    this.websocketService.stdPkgWebSocketURL
      .subscribe(stdPkgResponse => {
                if (stdPkgResponse[GlobalConstants.STDPKG]) {
          this.isDataLoading = false;
          this.stgPkgData = stdPkgResponse[GlobalConstants.STDPKG];
          // For IIT3-70 story
          this.standarPackageResults = this.stgPkgData;
          for (let i = 0; i < this.standarPackageResults?.length; i++) {
            let updatedTime = new Date(this.standarPackageResults[i]?.updatedTime);
            let timeDiff = Utils.getHourDifference(updatedTime);
            if (timeDiff >= 2 && this.standarPackageResults[i]?.packageStatus === 'pending') {
              this.standarPackageResults[i].packageStatus = '';
            }
          }
        this.preparePkgMetaData();
        }
        if (connectionWS < 1) {
          connectionWS += 1;
          let userType = (this.userInfo.role === this.storeUser || this.userInfo.role === this.retailUser || this.userInfo.role === this.regionalHQUser) ? GlobalConstants.CNCTD_LWR : GlobalConstants.UNCNCTD_LWR;
          this.commonService.fetchStandardPKGData(sessionStorage.getItem('retailerId'), userType)
            .pipe(takeUntil(this.ngUnsubscribe))
            .pipe(first())
            .subscribe(standardPackageData => {
            });
        }
      },
        error => {
          this.isDataLoading = false;
          Utils.handleError(error, this.constructor.name);
        });
    this.websocketService.stdPkgWebSocketURL.next({
      "userID": this.userInfo.userId
    });
  }
  openDownloadPkg(stndPack) {
    this.isGamingMessage = (stndPack == GlobalConstants.GAMING_LWR) ? true : false;
    this.showDownloadPopup = true;
    this.downloadPopUpData = this.filterPkgData(this.pkgMetaData[stndPack]);
    this.downloadPopUpData[0].fileName = this.downloadPopUpData[0].downloadURL.split(/[/ ]+/).pop();
  }
  copyPackageURL(inputElement) {
    inputElement.select();
    document.execCommand('copy');
    inputElement.setSelectionRange(0, 0);
  }
  downloadPackage() {
    this.setLanguageName(this.downloadPopUpData[0]?.languageCode); //For GA
    this.sendToGA(this.downloadPopUpData[0]); //For GA
    let checkExt = this.downloadPopUpData[0]?.fileName.split(/[. ]+/);
    const fileExt = '.' + checkExt[checkExt?.length - 1];
    this.commonService.downloadPackage(this.downloadPopUpData[0]?.downloadURL, this.downloadPopUpData[0]?.fileName, fileExt);
  }
  preparePkgMetaData() {
    for (let each in this.pkgMetaData) {
      this.pkgMetaData[each]['data'] = this.filterPkgData(this.pkgMetaData[each]);
    }
  }
  filterPkgData(inputData) {
    return this.stgPkgData.filter((each) => {
      return (each.standardPack === inputData.standardPack && each.packageType === inputData.packageType && each.languageCode === inputData.langObject.langCode.toLowerCase());
    });
  }
  getProgressbarBgColor(pbStatus) {
    return `radial-gradient(closest-side, white 79%, transparent 80% 100%),conic-gradient(#8BAE46 ${pbStatus * 3.6}deg, #E9E9E9 0)`;
  }
  preparePbValue(key) {
    let value: number;
    switch (this.pkgMetaData[key]?.data[0]?.progressStatus) {
      case GlobalConstants.PROGRESS_STATUS_INQUEUE: {
        value = 5;
        break;
      }
      case GlobalConstants.PROGRESS_STATUS_READ: {
        value = 25;
        break;
      }
      case GlobalConstants.PROGRESS_STATUS_ASSETDOWNLOADED: {
        value = 50;
        break;
      }
      case GlobalConstants.PROGRESS_STATUS_PACKAGECREATED: {
        value = 75;
        break;
      }
      case GlobalConstants.PROGRESS_STATUS_COMPLETED: {
        value = 100;
        break;
      }
      default: {
        value = 0;
        break;
      }
    }
    return value
  }
  prepareBtnText(key) {
    let userType = (this.userInfo.role === this.storeUser || this.userInfo.role === this.retailUser || this.userInfo.role === this.regionalHQUser) ? GlobalConstants.CNCTD_LWR : GlobalConstants.UNCNCTD_LWR;
    if (this.pkgMetaData[key]?.data?.length && this.pkgMetaData[key]?.data[0]?.packageStatus === GlobalConstants.CMP_LWR || (key === this.iposLite && userType === GlobalConstants.UNCNCTD_LWR)) {
      return GlobalConstants.DOWNLOAD_VAL;
    } else {
      return this.pkgMetaData[key]?.data?.length && this.pkgMetaData[key]?.data[0]?.packageStatus === GlobalConstants.PND_LWR ? GlobalConstants.GENERATING_VAL : GlobalConstants.GENERATE_VAL;
    }
  }
  decideTheClick(ip1, ip2, ip3, ip4) {
    let userType = (this.userInfo.role === this.storeUser || this.userInfo.role === this.retailUser || this.userInfo.role === this.regionalHQUser) ? GlobalConstants.CNCTD_LWR : GlobalConstants.UNCNCTD_LWR;
    if (this.pkgMetaData[ip4]?.data?.length && this.pkgMetaData[ip4]?.data[0]?.packageStatus === GlobalConstants.CMP_LWR || (ip4 === this.iposLite && userType === GlobalConstants.UNCNCTD_LWR)) {
      this.openDownloadPkg(ip4);
    } else if (!this.pkgMetaData[ip4]?.data[0]?.packageStatus || this.pkgMetaData[ip4]?.data[0]?.packageStatus === GlobalConstants.FLD_LWR || this.pkgMetaData[ip4]?.data[0]?.packageStatus == "" ) {
      this.selectDownloadPackage(ip1, ip2, ip3, ip4);
    }
  }
  //IIT2-5802 end
  setLanguageName(langCode: string) { //get langName by langCode
    if (langCode === 'en-us') {
      langCode = GlobalConstants.LANGUAGE_ENGLISH;
    }
    this.pkgLangForGA = this.langMappingsClone?.filter(element => {
      return element?.langCode === langCode;
    })[0]?.langInEng;
  }
  sendToGA(downloadPopUpData: any) { //send GA data on download button on pop-up
    let pkgTypeForGA = '';
    let pkgOsForGA = '';
    if (downloadPopUpData?.packageType === GlobalConstants.PACKAGE_TYPE_WIN) {
      pkgTypeForGA = downloadPopUpData?.standardPack;
      pkgOsForGA = GlobalConstants.WINDOWS;
    } else {
      pkgTypeForGA = downloadPopUpData?.packageType;
      if (pkgTypeForGA?.toLowerCase() === GlobalConstants.PACKAGE_TYPE_ISO.toLocaleLowerCase() || pkgTypeForGA?.toLowerCase() === GlobalConstants.PACKAGE_TYPE_DEB.toLowerCase()) {
        pkgOsForGA = GlobalConstants.LINUX;
      }
      else if (pkgTypeForGA?.toLowerCase()?.includes(GlobalConstants.UWP.toLowerCase())) {
        pkgOsForGA = GlobalConstants.WINDOWSUWP;
      }
      else if (pkgTypeForGA?.toLowerCase()?.includes(GlobalConstants?.CHROME.toLowerCase())) {
        pkgOsForGA = GlobalConstants.CHROME_TEXT;
      }
    }
    let pkgInfoForGA = pkgOsForGA + ' | ' + pkgTypeForGA + ' | ' + this.pkgLangForGA + ' | ' + GlobalConstants.STANDARD_PKG;
    this.googleAnalyticsService.downloadPackageTracking(pkgInfoForGA);
  }
  closeDemoModal(){
    this.modalReference.close();
  }
  enableGameDemo(content){
    this.modalReference = this.modalService.open(content, { backdrop: 'static',
    keyboard: false});
  }

  openUploadTemplate() {
    this.showXlsxError = false;
    this.showFileContentError = false;
    this.addTemplate.open();
  }
  closeUploadModal() {
    this.addTemplate.close();
  }

  onFilechange(fileInput: any) {
    this.showXlsxError = false;
    this.showFileContentError = false;
    let workBook = null;
    let jsonData = null;
    let dataString = null;
    const reader = new FileReader();
    const file = fileInput.target.files[0];
    this.fileName = fileInput.target.files[0].name.split('.')[0];
    const fileExtention = file.name.split('.').pop();
    reader.onload = (event) => {
      const data = reader.result;
      workBook = XLSX.read(data, { type: 'binary' });
      const sheetNames = workBook.SheetNames;
      const expectedSheets = ['Laptop', 'Specifications', 'Message', 'DemoToScenario'];
      if ((fileExtention || '').toLowerCase() !== 'xlsx') {
        this.showXlsxError = true;
        return;
      } else {
        this.showXlsxError = false;
        if (sheetNames) {
          for (let i = 0; i < sheetNames.length; i++) {
            if (!expectedSheets.includes(sheetNames[i])) {
              this.showFileContentError = true;
              return;
            }
          }
        } else {
          this.showFileContentError = false;
        }
      }
      jsonData = workBook.SheetNames.reduce((initial, name) => {
        const sheet = workBook.Sheets[name];
        initial[name] = XLSX.utils.sheet_to_json(sheet); //convert file to json
        return initial;
      }, {});
      dataString = JSON.stringify(jsonData);
      const url = AssetLibraryConstants.S3_ASSET_LIBRARY_RETAILERS + sessionStorage.getItem('retailerId')
        + '/product-mapping';
      this.httpMethodsservice.putFile(url + '/ProductMapping', dataString, true)
        .pipe(map((res: any) =>
          res))
        .subscribe(() => {
          this.PMFileExists = true;
          this.file = fileInput.target.files[0];
          fileInput.target.value = null;
          this.addTemplate.close();
        });
      this.httpMethodsservice.putXFile(url + '/Product-Mapping', fileInput.target.files[0], fileExtention, true)
        .pipe(map((res: any) => res))
        .subscribe(() => {
          this.selectDownloadPackage(this.iposLite,this.windowExt,this.iposLite,this.iposLite);
          let PMDetails = {
            productMapConfiguration: sessionStorage.getItem('retailerId'),
            packageType: GlobalConstants.IPOS_LITE,
            locale: 'zh-cn',
            standardPack:GlobalConstants.IPOS_LITE,
            pkgOperatingSystem: GlobalConstants.IPOS_LITE
          }
          this.commonService.generateProductMapDetails(PMDetails).pipe(takeUntil(this.ngUnsubscribe)).pipe(first()).subscribe(response => {
            this.commonService.getProductMapDetails(sessionStorage.getItem('retailerId')).pipe(takeUntil(this.ngUnsubscribe)).pipe(first()).subscribe(response => {
              this.uploadedDate = response?.standardPackage?.productMapLastUpdatedTime;
            });
          });
        });
    }
    reader.readAsBinaryString(file);
  }

  downloadPMFile() {
    const initialTemplateUrl = environment.apiBaseUrlAsset + AssetLibraryConstants.S3_ASSET_LIBRARY_RETAILERS + sessionStorage.getItem('retailerId')
    + '/product-mapping/SampleProductMapping.xlsx';
    const link = document.createElement('a');
    link.setAttribute('target', '_blank');
    link.setAttribute('href', initialTemplateUrl);
    link.setAttribute('download','SampleProductMapping.xlsx');
    document.body.appendChild(link);
    link.click();
  }

  downloadModifiedTemplate() {
    const url = environment.apiBaseUrlAsset + AssetLibraryConstants.S3_ASSET_LIBRARY_RETAILERS + sessionStorage.getItem('retailerId')
    + '/product-mapping/Product-Mapping';
    const link = document.createElement('a');
    link.setAttribute('target', '_blank');
    link.setAttribute('href', url);
    link.setAttribute('download', this.templateName);
    document.body.appendChild(link);
    link.click();
  }
}